import variables from '../variables'

import type { CarouselOverrideToken } from './types'

const Carousel: CarouselOverrideToken = {
  dotWidth: variables.space,
  dotHeight: variables.space,
  dotWidthActive: variables.space
} as const

export default Carousel
